export default __webpack_public_path__ + "static/media/langusty.7012aa25.jpg";